import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class PlatformDetectorService {
  private _isRunningAsApp?: boolean;

  constructor() {}

  public get isRunningAsApp(): boolean {
    if (this._isRunningAsApp === undefined) {
      const forceAppMode = localStorage.getItem('forceAppMode');
      if (forceAppMode === 'true') {
        console.log('Forcing app mode via localStorage "forceAppMode"');
        this._isRunningAsApp = true;
      } else {
        this._isRunningAsApp = !globalThis.isPwa;
      }
      console.log(
        `PlatformDetectorService: isRunningAsApp = ${this._isRunningAsApp}`
      );
    }
    return this._isRunningAsApp;
  }
}
